"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
function compareScenes(a, b, alpha) {
    var compareEpNums;
    if (a.episode_number && b.episode_number) {
        compareEpNums = compareEpisodeNumber(a.episode_number, b.episode_number);
    }
    else if (a.episode_number) {
        compareEpNums = 1;
    }
    else if (b.episode_number) {
        compareEpNums = -1;
    }
    if (compareEpNums) {
        return compareEpNums;
    }
    else {
        var result = compareSceneNames(a.name, b.name, alpha);
        // If the scenes sort absolutely the same, sort them alphabetically
        return result || compareStrings(a.name, b.name);
    }
}
exports.compareScenes = compareScenes;
// Each pattern in this object will be searched for in scene names by its match property.
// If the match is found, we sort it accordingly by its place.  -1 sorts before, 1 after other scenes
// If the match is found in both scenes, we remove the pattern, by the remove property, or match if remove doesn't exist
// We then continue to compare the scenes
var patterns = [
    {
        match: /(cold\s*open(ing)?|\bc[.\/]?o)([^a-z]|\b)/i,
        remove: /(cold\s*open(ing)?|\bc[.\/]?o)([.-]?)/i,
        place: -1,
    },
    { match: /prologue([^a-z]|\b)/i, remove: /prologue[.-]?/i, place: -1 },
    { match: /teaser([^a-z]|\b)/i, remove: /teaser[.-]?/i, place: -1 },
    { match: /(\btag[^A-z]?)/i, remove: /(\btag)/i, place: 1 },
    { match: /epilogue([^a-z]|\b)/i, remove: /epilogue[.-]?/i, place: 1 },
    { match: /\bact([^A-z]|\b)/i, remove: /\bact\s*[.-]?/i, place: 1 },
    {
        match: /(\bsc(ene)?([^A-z]|\b))/i,
        remove: /(\bsc(ene)?\s*[.-]?)/i,
        replace: '-',
        place: 1,
    },
    {
        match: /((fb|flashback)([^A-z]|\b))/i,
        remove: /(fb|flashback)\s*[.-]?/i,
        replace: '$-',
        place: 0,
    },
];
// Each of these patterns is used to split scene names into parts
// The scenes will be only be split by the split property if matched by the match property first
// If there are multiple occurences of the pattern, the first split is compared, and the rest are joined by the
// replace property, and sent through the function again. (so the pattern will be found again)
var part_patterns = [
    {
        split: /(?!^)(?:p(?:(?:a?r)?t\s*[.-]?|\s*[.-]?)\s*)/i,
        splitAlpha: /(?:p(?:(?:a?r)?t\s*[.-]?|\s*[.-])\s*)/i,
        match: /(?!^)(p((a?r)?t\s*[.-]?|\s*[.-]|\s*[^a-z\s])\s*)/i,
        replace: 'part',
    },
    { split: /-\s*/, match: /-\s*/, replace: '-' },
];
function compareSceneNames(a, b, alpha) {
    // console.log('compareSceneNames('+a+', '+b+', '+alpha+')');
    var result;
    if (bothEmpty(a, b)) {
        return 0;
    }
    else if ((result = oneEmpty(a, b))) {
        return result;
    }
    else {
        a = a.trim();
        b = b.trim();
        // find and recurse over special cases
        for (var i = 0; i < patterns.length; i++) {
            var p = patterns[i];
            var a_match = a.match(p.match);
            var b_match = b.match(p.match);
            if (!bothEmpty(a_match, b_match)) {
                result = oneEmpty(a_match, b_match) * p.place; // sort before or after
                if (result) {
                    return result;
                }
                else {
                    // both matched
                    var remove = p.remove || p.match;
                    var replace = p.replace || '';
                    a = a.replace(remove, replace).trim();
                    b = b.replace(remove, replace).trim();
                }
            }
        }
        // reads commas as seperating a list of scenes; compares the 1st scenes, then subsequent scenes
        var a_scenes = a.split(',');
        var b_scenes = b.split(',');
        if (a_scenes.length > 1 || b_scenes.length > 1) {
            var scene_result = compareSceneNames(a_scenes[0], b_scenes[0], alpha);
            if (scene_result) {
                return scene_result;
            }
            else if (a_scenes.length > 1 && b_scenes.length > 1) {
                return compareSceneNames(a_scenes.slice(1).join(','), b_scenes.slice(1).join(','), alpha);
            }
            else if (a_scenes.length > 1) {
                return 1;
            }
            else if (b_scenes.length > 1) {
                return -1;
            }
        }
        else {
            // split into parts using different patterns
            // compare first part, then subsequent parts.
            for (var j = 0; j < part_patterns.length; j++) {
                var pp = part_patterns[j];
                var pp_split = alpha && pp.splitAlpha ? pp.splitAlpha : pp.split;
                var a_parts = a.match(pp.match) ? a.split(pp_split) : [a];
                var b_parts = b.match(pp.match) ? b.split(pp_split) : [b];
                if (a_parts.length > 1 || b_parts.length > 1) {
                    var compare_first = compareSceneNames(a_parts[0], b_parts[0], alpha);
                    // if the first parts differ, sort by that
                    if (compare_first) {
                        return compare_first;
                        // else compare the rest of the parts, joined in a list
                    }
                    else if (a_parts.length > 1 && b_parts.length > 1) {
                        return compareSceneNames(a_parts.slice(1).join(pp.replace), b_parts.slice(1).join(pp.replace), alpha);
                    }
                    else if (a_parts.length > 1) {
                        return 1;
                    }
                    else if (b_parts.length > 1) {
                        return -1;
                    }
                }
            }
            // now that the scenes are reduced to a single part, we can compare them
        }
        return alpha ? compareStrings(a, b) : compareParts(a, b);
    }
}
exports.compareSceneNames = compareSceneNames;
function compareParts(a, b) {
    // console.log('compareParts('+a+', '+b+')');
    var result;
    if (bothEmpty(a, b)) {
        return 0;
    }
    else if ((result = oneEmpty(a, b))) {
        return result;
    }
    else {
        var a_nums = a.split('.');
        var b_nums = b.split('.');
        var num_result = compareSceneNumber(a_nums[0], b_nums[0]);
        if (num_result) {
            return num_result;
        }
        else if (a_nums.length > 1 && b_nums.length > 1) {
            return compareParts(a_nums.slice(1).join('.'), b_nums.slice(1).join('.'));
        }
        else if (a_nums.length > 1) {
            return 1;
        }
        else if (b_nums.length > 1) {
            return -1;
        }
        else {
            return 0;
        }
    }
}
exports.compareParts = compareParts;
function compareSceneNumber(a, b) {
    // console.log('compareSceneNumber('+a+', '+b+')');
    a = a.trim();
    b = b.trim();
    var a_match = a.match(/(\d+)/);
    var b_match = b.match(/(\d+)/);
    if (!(a_match || b_match)) {
        // neither
        return compareStrings(a, b);
    }
    else if (!a_match) {
        return -1;
    }
    else if (!b_match) {
        return 1;
    }
    else {
        var a_num = parseInt(a_match[0], 10);
        var b_num = parseInt(b_match[0], 10);
        if (a_num > b_num) {
            return 1;
        }
        else if (a_num < b_num) {
            return -1;
        }
        else {
            return compareStrings(a.replace(/(\d+)/, '~'), b.replace(/(\d+)/, '~'));
        }
    }
}
function compareEpisodeNumber(a, b) {
    return compareSceneNumber(a, b);
}
exports.compareEpisodeNumber = compareEpisodeNumber;
function compareStrings(a, b) {
    // this function is case SENSITIVE
    if (a > b) {
        return 1;
    }
    else if (a < b) {
        return -1;
    }
    else {
        return 0;
    }
}
function bothEmpty(a, b) {
    if (empty(a) && empty(b)) {
        return true;
    }
    return false;
}
function oneEmpty(a, b) {
    if (empty(a) && !empty(b)) {
        return -1;
    }
    else if (empty(b) && !empty(a)) {
        return 1;
    }
    else {
        return 0;
    }
}
function empty(v) {
    if (typeof v === 'undefined' || v === null || v === '') {
        return true;
    }
    return false;
}
function compareAlphanum(a, b) {
    for (var x = 0; a[x] && b[x]; x++) {
        if (a[x] !== b[x]) {
            var c = Number(a[x]), d = Number(b[x]);
            if (isNaN(c) || isNaN(d)) {
                return a[x] > b[x] ? 1 : -1;
            }
            else {
                return c - d;
            }
        }
    }
    return a.length - b.length;
}
exports.compareAlphanum = compareAlphanum;
function decodeScriptDayForSort(a) {
    var script_day = __rest(a, []);
    if (!script_day) {
        script_day = Infinity;
    }
    return script_day;
}
exports.decodeScriptDayForSort = decodeScriptDayForSort;
